import React from 'react'
import { CashbackInfo } from './CashbackInfo'
import { Questions } from './Questions'
import { Spotlight } from './Spotlight'
import { StepsExplanation } from './StepsExplanation'

const LandingCashbackDms = () => {
  return (
    <div className='landing-cashback'>
      <Spotlight />
      <CashbackInfo />
      <StepsExplanation />
      <Questions />
    </div>
  )
}

export default LandingCashbackDms



// WEBPACK FOOTER //
// ./src/features/LandingPage/LandingCashbackDms/LandingCashbackDms.js